import React, { Component } from 'react';
import { GeckoCard, Spinner } from '../../components';
import { $stateParams } from '../../router';
import { Auth, ClientManager } from '../../services';

export class LogoutPage extends Component {

    redirectUrl(client = null, app = null) {
        if (client && app) {
            return `/login/?client=${client}&app=${app}`;
        }
        return '/login/';
    }

    logout() {
        if ($stateParams.client && $stateParams.app) {
            // If the query paramaters are set in the url then persist them 
            // to local storage before redirecting the user to cognito as we 
            // cant pass the params in the redirect
            ClientManager.client($stateParams.client);
            ClientManager.app($stateParams.app);
        } else {
            // Clear the local storage just in case anything is still persisted
            ClientManager.clear();
        }

        return Auth.destroy().then(response => {
            if (response && response.Redirect && response.Redirect !== '/logout') return window.location.href = response.Redirect;

            // Fallback back to login page when no redirect is returned
            window.location.href = this.redirectUrl($stateParams.client, $stateParams.app);
        });
    }

    componentDidMount()
    {
        this.logout();
    }

    renderLoading()
    {
        return (
            <div className="row text mt-3 mb-3">
                <div className="col d-flex flex-column align-items-center">
                    <Spinner size="small" color="blue" />
                    Logging out...
                </div>
            </div>
        )
    }

    render() {
        return (
            <GeckoCard padded={true}>
                {this.renderLoading()}
            </GeckoCard>
        );
    }

}

export default LogoutPage;